import React from 'react';
import styled from 'styled-components';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Section from '../../components/Section';
import {
  removeSelectedBeeId,
  addSelectedBeeId,
  selectBeesWithIsSelected,
  selectSelectedBeeIds,
  setSelectedBeeIds,
  addSelectedBeeIds,
} from '../../ducks/bees';
import FilterableList from '../../components/FilterableList';
import { componentsEnum } from '../../utils/types';
import { beeFilters } from '../../utils/filters';
import SubjectCard from '../../components/SubjectCard';
import { parseCopyRightText } from '../../utils/valuesToHumanReadable';

const SubjectCardWithOpacity = styled(SubjectCard)`
  opacity: ${(props) => (props.isSelected ? 1 : 0.8)}
`;

const ManualSelection = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const beesWithIsSelected = useSelector(selectBeesWithIsSelected);
  const selectedBeeIds = useSelector(selectSelectedBeeIds);
  const isNextNavDisabled = selectedBeeIds.length === 0;

  return (
    <Section
      noCentering
      previousNav={{
        disabled: false,
        handleClick: () => history.push(
          componentsEnum.properties[componentsEnum.beeSelectionMethod].route,
        ),
      }}
      nextNav={{
        disabled: isNextNavDisabled,
        handleClick: () => history.push(
          componentsEnum.properties[componentsEnum.plantSelectionMethod].route,
        ),
      }}
      nextNavSticky
      {...props}
    >
      <Row className="justify-content-md-center">
        <Col className="text-center" md={10}>
          <h2>Handmatige selectie</h2>
        </Col>
      </Row>
      <FilterableList
        filterConfig={beeFilters}
        searchableByProperties={['dutchName', 'scientificName']}
        data={beesWithIsSelected}
        quickSelect={{
          handleDeselectAll: () => {
            dispatch(setSelectedBeeIds([]));
          },
          selectedCount: selectedBeeIds.length,
          handleSelectResults: (results) => {
            const ids = results.map((result) => result.id);
            dispatch(addSelectedBeeIds(ids));
          },
        }}
        render={(filteredData) => filteredData.map((bee) => (
          <SubjectCardWithOpacity
            md={6}
            lg={4}
            key={bee.id}
            title={bee.dutchName}
            subtitle={bee.scientificName}
            imagePath={bee.imagePath}
            copyrightText={parseCopyRightText(bee)}
            propertiesToList={[
              {
                key: 'Rode lijst',
                value: bee.isRedList ? 'Ja' : 'Nee',
              },
            ]}
            ranges={bee.flightTimes}
            rangesHeading="Vliegtijd"
            handleClick={() => (bee.isSelected
              ? dispatch(removeSelectedBeeId(bee.id))
              : dispatch(addSelectedBeeId(bee.id)))}
            isSelected={bee.isSelected}
          />
        ))}
      />
    </Section>
  );
};

export default ManualSelection;
